import React, { useState, useEffect } from 'react';
import { useFirebaseContext } from '../../../context';
import { Core } from '../..';
import { DEFAULT_COLOR, DEFAULT_COLORL2 } from '../../../constants';
import { FaChevronLeft, FaPaperPlane } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

export default function ResetPassword({
  forwardedHeight,
  showResetPasswordBox,
  setShowResetPasswordBox,
}) {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState(null);
  const { firebase } = useFirebaseContext();

  const isInvalid = email === '';

  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;
    if (name === 'userEmail') {
      setEmail(value);
    }
  };

  useEffect(() => {
    setError('');
  }, []);

  const sendResetEmail = (event) => {
    event.preventDefault();

    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        setEmailSent(true);
        setTimeout(() => {
          setEmailSent(false);
        }, 3000);
      })
      .catch((error) => {
        setEmail('');
        setEmailSent(false);
        setError(error.message);
      });
  };

  return (
    <div
      style={{
        height: forwardedHeight,
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <Core.Title>Reset Password.</Core.Title>

      <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
        {showResetPasswordBox && emailSent && (
          <Core.Success>An email has been sent to you!</Core.Success>
        )}
        {showResetPasswordBox && error !== null && error != '' && (
          <Core.Error>{error}</Core.Error>
        )}

        <div>
          <Core.Input
            autoFocus
            type='email'
            name='userEmail'
            value={email}
            placeholder='Email address'
            onChange={onChangeHandler}
          />
        </div>

        <Core.Button
          style={{ marginTop: '15px' }}
          color='white'
          bg={DEFAULT_COLOR}
          disabled={isInvalid}
          normal={true}
          type='button'
          onClick={(event) => {
            setError('');
            sendResetEmail(event);
          }}
        >
          <div
            style={{
              width: '100%',
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <FaPaperPlane
              style={{ height: '100%', position: 'absolute', left: 0 }}
            />

            {useMediaQuery({
              maxWidth: 387,
            }) ? (
              <span>Send a link</span>
            ) : (
              <span>Send a reset password link</span>
            )}
          </div>
        </Core.Button>
        <div style={{ display: 'flex', flex: 1, alignItems: 'flex-end' }}>
          <Core.Button
            style={{ marginTop: '10px' }}
            color={DEFAULT_COLOR}
            bg={DEFAULT_COLORL2}
            shadowBorder={true}
            normal={true}
            type='button'
            onClick={() => {
              setError('');
              setShowResetPasswordBox(false);
            }}
          >
            <div
              style={{
                width: '100%',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <FaChevronLeft
                style={{ height: '100%', position: 'absolute', left: 0 }}
              />
              <span>Back</span>
            </div>
          </Core.Button>
        </div>
      </div>
    </div>
  );
}
